import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { Input as ReactstrapInput, InputProps as ReactstrapInputProps } from 'reactstrap';
import React, { useState } from 'react';

const StyledInput = styled(ReactstrapInput, {
  shouldForwardProp: (prop) => prop !== '$error' && prop !== '$disabledColor',
})`
  width: 100%;
  padding: 9px 12px;
  gap: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  border: 1px solid #efefef;

  ${({ $error }) => ($error ? 'border-color: red;' : '')}

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    ${({ $error }) => ($error ? 'color: red;' : '')}
  }

  &:disabled {
    ${({ $disabledColor }) =>
      $disabledColor
        ? `border-color: ${$disabledColor}; background-color: ${$disabledColor};`
        : 'border-color: #d9d9d9; background-color: #d9d9d9;'}
  }
`;

export type InputProps = Omit<ReactstrapInputProps, 'placeholder' | 'title'> & {
  placeholder?: string | null;
  auth?: boolean;
  disabledColor?: string;
};

export const Input: React.FC<InputProps> = observer(({ placeholder = '', invalid, disabledColor, ...moreProps }) => {
  return <StyledInput $error={invalid} invalid={invalid} placeholder={placeholder ?? ''} $disabledColor={disabledColor} {...moreProps} />;
});
